import React, { useState, useEffect } from "react";
import { FaRegUser } from "react-icons/fa6";
import axios from "axios";
import { API_URLS } from "./../../urls";
import { IoEyeOutline } from "react-icons/io5";
import { IoEyeOffSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { IoReturnDownBackOutline } from "react-icons/io5";

export default function ForgetPassword() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isPasswordVisibleRepeat, setIsPasswordVisibleRepeat] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const otpRequested = localStorage.getItem("changePass");
    if (!otpRequested) {
      navigate("/forget_password");
    }
  }, [navigate]);
  const goBack = () => {
    navigate(-1);
  };
  const handlePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handlePassworRepeatdVisibility = () => {
    setIsPasswordVisibleRepeat(!isPasswordVisibleRepeat);
  };

  useEffect(() => {
    const storedPhoneNumber = localStorage.getItem("phone_number");
    if (storedPhoneNumber) {
      setPhoneNumber(storedPhoneNumber);
    }
  }, []);

  // const handlePhoneNumberChange = (e) => {
  //     const value = e.target.value.replace(/\D/g, '');
  //     if (value.length <= 11) {
  //         setPhoneNumber(value);
  //     }
  // };

  const handleNewPasswordChange = (e) => {
    const password = e.target.value;
    setNewPassword(password);

    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}/.test(password)) {
      setPasswordError(
        "رمز عبور باید حداقل ۸ کاراکتر باشد و شامل حروف بزرگ، حروف کوچک و اعداد باشد."
      );
    } else {
      setPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const confirmPass = e.target.value;
    setConfirmPassword(confirmPass);

    if (confirmPass !== newPassword) {
      setConfirmPasswordError("رمز های عبور وارد شده یکسان نمی باشد.");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handleChangePassword = async () => {
    if (passwordError || confirmPasswordError) {
      return;
    }

    const accessToken = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");

    const data = {
      phone_number: phoneNumber,
      new_password: newPassword,
    };

    const config = {
      method: "patch",
      url: `${API_URLS.BASE_URL}auth/change_password`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: data,
    };

    setIsLoading(true);

    try {
      const response = await axios.request(config);
      setIsLoading(false);
      window.location.href = "/login";
    } catch (error) {
      setIsLoading(false);
      console.log("Error changing password:", error);
      setErrorMessage("مشکلی در تغییر رمز عبور پیش آمده است.");
      setTimeout(() => setErrorMessage(""), 5000);
    }
  };

  const isFormValid =
    !passwordError && !confirmPasswordError && newPassword && confirmPassword;

  return (
    <div className='flex w-full bg-[#F3F5F6] flex-col-reverse md:flex-row'>
      <div className='flex flex-col w-full lg:w-1/2 justify-center items-center'>
        <img src='images/logo-bime.svg' alt='' className='my-5 ' />
        <div className='w-[100%] md:w-[50%] flex flex-col items-center justify-center text-center rounded-lg py-6'>
          <p className='text-center mb-6 text-[#055187] text-[24px]'>
            تعیین رمز عبور جدید
          </p>
          <div className='w-full flex flex-col items-center justify-center text-center my-2'>
            <div className='relative mb-3 w-[85%]'>
              <FaRegUser className='absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500' />
              <input
                className='w-full py-3 border border-solid rounded-[40px] pl-10 pr-9'
                type={isPasswordVisible ? "text" : "password"}
                placeholder='رمز عبور جدید'
                value={newPassword}
                onChange={handleNewPasswordChange}
              />
              <span
                className='absolute left-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500'
                onClick={handlePasswordVisibility}
              >
                {isPasswordVisible ? <IoEyeOffSharp /> : <IoEyeOutline />}
              </span>
            </div>
            {passwordError && (
              <p className='flex items-right pb-2 w-[85%] text-[#ff1942] text-[10px] '>
                {passwordError}
              </p>
            )}
            <div className='relative w-[85%]'>
              <FaRegUser className='absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500' />
              <input
                className='w-full py-3 border border-solid rounded-[40px] pl-10 pr-9'
                type={isPasswordVisibleRepeat ? "text" : "password"}
                placeholder='تکرار رمز عبور جدید'
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
              />
              <span
                className='absolute left-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500'
                onClick={handlePassworRepeatdVisibility}
              >
                {isPasswordVisibleRepeat ? <IoEyeOffSharp /> : <IoEyeOutline />}
              </span>
            </div>
            {confirmPasswordError && (
              <p className='flex items-right pb-2 w-[85%] text-[#ff1942] text-[10px] '>
                {confirmPasswordError}
              </p>
            )}
          </div>

          <div className='w-[85%] flex flex-col justify-center mt-4'>
            <button
              type='submit'
              disabled={!isFormValid || isLoading}
              onClick={handleChangePassword}
              className={`w-full ${
                !isFormValid && !isLoading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#02bfe7]"
              } text-white rounded-[40px] border-none py-3 mt-1 flex items-center justify-center ${
                isLoading ? "cursor-not-allowed" : "cursor-pointer"
              }`}
            >
              {isLoading ? (
                <div className='w-full h-5 animate-bounce'>تغییر رمز عبور</div>
              ) : (
                <p>تغییر رمز عبور</p>
              )}
            </button>
          </div>
        </div>
      </div>
      <div
        className='flex cursor-pointer items-start mt-5 pl-2'
        onClick={goBack}
      >
        <IoReturnDownBackOutline color='#055187' />
        <p className='px-3 text-[#055187]'>بازگشت</p>
      </div>
      <div
        className='lg:w-1/2 flex justify-center md:w-1/2 bg-no-repeat bg-cover h-[30vh] md:h-[100vh]'
        style={{
          backgroundImage: `url(images/loginPage.png)`,
        }}
      >
        <img
          src='images/logoName.svg'
          className='w-[20%] justify-center'
          alt=''
        />
      </div>
    </div>
  );
}
